export default __webpack_public_path__ + "static/media/Dyslipidemia-1.0534cb11.jpg";